<div class="col-12" [class.override]="storefrontId === 572">
  <div class="flex flex-column justify-content-center align-items-center" style="min-height: 300px">
    <p class="text-center text-lg text-500">{{ message() }}</p>
  </div>
</div>
